import axios from "axios";
import end from './endpoint';
import auth from "./auth";
const ENDPOINT = end.PATH + "final/";

export default {
    get(subject, semester, group, period) {
        const token = auth.getSession();
        return axios.get(ENDPOINT + "list/" + subject + "/" + semester + "/" + group + "/" + period, { headers: { token } });
    },

    getSICOBA(semester, group, period, mode) {
        const token = auth.getSession();
        return axios.get(ENDPOINT + "sicoba/list/" + mode + "/" + semester + "/" + group + "/" + period, { headers: { token } });
    },

    getOne(id) {
        const token = auth.getSession();
        return axios.get(ENDPOINT + id, { headers: { token } });
    },

    getBy(lesson, student, period) {
        const token = auth.getSession();
        return axios.get(ENDPOINT + "select/" + lesson + "/" + student + "/" + period, { headers: { token } });
    },

    insert(control) {
        const token = auth.getSession();
        return axios.post(ENDPOINT, control, { headers: { token } });
    },

    update(id, control) {
        const token = auth.getSession();
        return axios.put(ENDPOINT + id, control, { headers: { token } });
    },

    updateBy(lesson, student, period, control) {
        const token = auth.getSession();
        return axios.put(ENDPOINT + lesson + "/" + student + "/" + period, control, { headers: { token } });
    },

    delete(id) {
        const token = auth.getSession();
        return axios.delete(ENDPOINT + id, { headers: { token } });
    },
};